import { uniqueId } from "lodash";
import { MdOutlineDragIndicator } from "react-icons/md";
import { IoCopy } from "react-icons/io5";
import { IoMdTrash } from "react-icons/io";

const FormField = ({
  translate,
  field,
  formIndex,
  index,
  fieldIndex,
  selectedField,
  setSelectedField,
  isEditing,
  formTemplate,
  setFormTemplate,
  ...rest
}) => {
  const handleCopy = (e, item) => {
    e.stopPropagation();
    e.preventDefault();

    const newFormTemplate = [...formTemplate];

    const newField = [...newFormTemplate[formIndex].fields];

    const newFieldItem = { ...item };

    newFieldItem.id = uniqueId(`copy-`);
    newFieldItem.field_code = `${newFieldItem.field_code}_1`;

    if (`repeatedFieldIndex` in rest) {
      const newRepeatedField = [...newField[fieldIndex].repeatedFields];
      newRepeatedField.splice(rest.repeatedFieldIndex + 1, 0, newFieldItem);
      newField[fieldIndex].repeatedFields = newRepeatedField;
    } else {
      newField.splice(fieldIndex + 1, 0, newFieldItem);
    }

    newFormTemplate[formIndex].fields = newField;

    setFormTemplate(newFormTemplate);
    setSelectedField(null);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    e.preventDefault();

    const newFormTemplate = [...formTemplate];

    const newField = [...newFormTemplate[formIndex].fields];

    if (`repeatedFieldIndex` in rest) {
      const newRepeatedField = [...newField[fieldIndex].repeatedFields];
      newRepeatedField.splice(rest.repeatedFieldIndex, 1);
      newField[fieldIndex].repeatedFields = newRepeatedField;
    } else {
      newField.splice(fieldIndex, 1);
    }

    newFormTemplate[formIndex].fields = newField;

    setFormTemplate(newFormTemplate);

    setSelectedField(null);
  };

  return (
    <div
      className="form-field-item align-items-center w-100"
      onClick={() =>
        selectedField?.id === field.id
          ? setSelectedField(null)
          : isEditing
            ? setSelectedField({
              ...field,
              formIndex,
              fieldIndex,
              repeatedFieldIndex:
                `repeatedFieldIndex` in rest ? rest.repeatedFieldIndex : null,
            })
            : false
      }
      data-is-selected-field={selectedField?.id === field.id ? true : false}
    >
      <div className="form-field-item-label d-flex justify-content-start align-items-center h-100">
        <span>{field?.field_label ? field?.field_label : ""}</span>
      </div>
      <div className="form-field-item-type d-flex justify-content-between align-items-center h-100">
        <div className="left-side d-flex justify-content-start align-items-center">
          {isEditing && (
            <span className="drag-trigger cursor--grab">
              <MdOutlineDragIndicator/>
            </span>
          )}
          <span className="type-label text-uppercase">
            {translate(`form_fields.uppercase_translates.${field.fieldType}`)}
          </span>
        </div>
        {isEditing && (
          <div className="right-side d-flex justify-content-end align-items-center">
            <span
              className="copy-button me-2"
              role="button"
              onClick={(e) => handleCopy(e, field)}
            >
              <IoCopy size={14}/>
            </span>
            <span
              className="remove-button"
              role="button"
              onClick={(e) => handleDelete(e)}
            >
              <IoMdTrash/>
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormField;
